import * as React from 'react';
import { Dispatch } from 'react-redux';
import { Translate } from 'react-redux-i18n';

import { StoreState } from '../../reducers';
import { Button } from './styles';
import Tooltip from '../Tooltip';
import Utils from '../../utils';
import UserAgentUtils from '../../utils/userAgent';
import { toggleNotesEditor } from '../../containers/NotesPage/actions';
import { MenuPosition } from '../../typings/menu';
import { StyledMenuItem, StyledMenuItemLink } from '../MenuManager/Left/MenuItem/styles';
import { getMenuButtonIcon } from '../../utils/menuManager';

interface ButtonCreateNoteProps {
	isActive: boolean;
	position: MenuPosition;
	iconSrc: string;
	icon?: string;
	label?: string;
	dispatch: Dispatch<StoreState>;
}

const ButtonCreateNote = ({ isActive, position, iconSrc, label, dispatch }: ButtonCreateNoteProps) => {
	if (position === MenuPosition.burger) {
		return (
			<StyledMenuItem
				className="ButtonCreateNote menu-item notes"
				onClick={() => dispatch(toggleNotesEditor())}
			>
				<StyledMenuItemLink>
					{getMenuButtonIcon(iconSrc, 'iconset_uprez_write')}
					{label || <Translate value="messages.create_note" />}
				</StyledMenuItemLink>
			</StyledMenuItem>
		);
	}

	const tooltipId = Utils.generateId();

	return (
		<Button
			className="ButtonCreateNote"
			type="button"
			isActive={isActive}
			data-tip={true}
			data-for={tooltipId}
			onClick={() => dispatch(toggleNotesEditor())}
		>
			{getMenuButtonIcon(iconSrc, 'iconset_create_note')}
			{UserAgentUtils.isDesktop() &&
				<Tooltip id={tooltipId} text={label || 'messages.create_note'} />
			}
		</Button>
	);
};

export default ButtonCreateNote;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ButtonCreateNote/index.tsx